"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("./constants");

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _find = _interopRequireDefault(require("lodash/find"));

var _replace = _interopRequireDefault(require("lodash/replace"));

var _reactRouter = require("react-router");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  availableRoutes: [],
  breadCrumb: [],
  activePath: '',
  hideBackButton: false
};

var _getActivePage = function _getActivePage(state, pathname) {
  var pathToMath = pathname;

  if (state.basename) {
    pathToMath = (0, _replace["default"])(pathname, state.basename, '');
  }

  var routes = (0, _flatten["default"])(state.availableRoutes.map(function (route, index) {
    if (typeof route === 'function') {
      return route();
    } else {
      return route;
    }
  }));
  return (0, _find["default"])(routes, function (route) {
    var match = (0, _reactRouter.matchPath)(pathToMath, {
      path: route.path || route.pattern,
      // Use path instead of pattern, pattern won't be supported in a next version
      exact: route.exactly,
      strict: route.strict
    });
    return match !== null;
  });
};

var _getBreadCrumb = function _getBreadCrumb(activePage) {
  return activePage ? [activePage.pageTitle] : [];
};

var _getNewState = function _getNewState(oldState, pathName) {
  var state = _objectSpread({}, oldState, {
    activePath: pathName,
    activePage: _getActivePage(oldState, pathName)
  });

  state.breadCrumb = _getBreadCrumb(state.activePage);
  state.pathToLeaveFocusView = state.activePage ? state.activePage.pathToLeaveFocusView : undefined;
  state.focusViewComponent = state.activePage ? state.activePage.focusViewComponent : undefined;
  state.isFocusView = state.pathToLeaveFocusView !== undefined;
  state.hideNav = state.activePage && state.activePage.hideNav;
  state.hideBackButton = state.activePage && state.activePage.hideBackButton ? state.activePage.hideBackButton : false;
  return state;
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.LOCATION_CHANGE:
      return _getNewState(state, action.payload.pathname);

    case _constants.AVAILABLE_ROUTES:
      {
        var stateWithAvaibleRoutes = _objectSpread({}, state, {
          availableRoutes: action.payload,
          basename: action.basename
        });

        return _objectSpread({}, stateWithAvaibleRoutes, {}, _getNewState(stateWithAvaibleRoutes, window.location.pathname));
      }

    case _constants.SET_PAGE_TITLE:
      {
        return _objectSpread({}, state, {
          breadCrumb: [action.title]
        });
      }
  }

  return state;
};

var _default = reducer;
exports["default"] = _default;